<template>
  <v-card class="d-flex flex-column item" height="100%" :to="to" tile flat>
    <div class="position-relative">
      <v-chip
        v-if="reference"
        class="white--text item-type"
        color="secondary"
        small
      >
        #{{ reference }}
      </v-chip>

      <img class="d-block item-img" :src="img" :alt="title" width="100%" />
    </div>

    <div class="white py-3 px-4 item-caption">
      <div
        class="
          grey--text
          text--darken-2 text-body-1 text-uppercase
          font-weight-medium
          item-caption-title
        "
        v-if="title"
      >
        {{ title }}
      </div>

      <div class="primary--text text-h6 font-weight-bold mt-1" v-if="price">
        {{ price }}
      </div>
    </div>

    <div class="mt-auto pb-3 px-4">
      <v-sheet
        class="justify-center pb-1 pt-3 item-caption-details"
        width="100%"
      >
        <template v-for="({ icon, text }, index) in details">
          <div
            :key="index"
            v-if="text"
            class="px-2 d-flex align-center justify-center"
          >
            <v-icon class="grey--text text--darken-2" size="14">
              {{ icon }}
            </v-icon>
            <div
              class="
                grey--text
                text--darken-2 text-caption
                font-weight-medoim
                ml-2
                item-caption-detail-text
              "
            >
              {{ text }}
            </div>
          </div>
        </template>
      </v-sheet>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    reference: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "",
    },
    details: {
      type: Array,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  box-shadow: 0px 50px 70px -20px rgba(64, 62, 62, 0.1) !important;
  transition: all 0.1s linear;

  &:hover {
    box-shadow: 0px 40px 70px -20px rgba(64, 62, 62, 0.2) !important;

    .item-img {
      opacity: 0.9;
    }
  }

  &-type {
    left: 10px;
    position: absolute;
    top: 10px;
    z-index: 1;
  }

  &-img {
    aspect-ratio: 16 / 9;
    -o-object-fit: cover;
    object-fit: cover;
    transition: all 0.1s linear;
  }

  &-caption {
    &-title {
      line-height: 1.3;
      transition: all 0.1s linear;
    }
  }

  &-caption-details {
    border-top: 1px solid #e6e6e6;
    display: grid !important;
    grid-template-columns: auto auto auto auto auto;
  }
}
</style>
